import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const Terceirizados = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="SERVIÇOS TERCEIRIZADOS" />
                    <div style={{ textAlign: "left" }}>
                        <Select valor={props.valor} label="Formato de Prestação do Serviço" nome="formato" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Equipe Híbrida", "Equipe Terceirizada"]} />
                        <Input label="CNPJ" nome="cnpj" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="17vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Nome da Empresa" nome="empresa" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="57vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Responsável Técnico" nome="responsavelTecnico" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="17vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Número de Registro" nome="numeroRegistro" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="17vw" widthMobile="80vw" marginR="3vw" />
                        <Select valor={props.valor} label="Tipo de Endereço" nome="tipoEndereco" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Físico", "Caixa Postal"]} />
                        <Input label="Endereço" nome="endereco" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="57vw" widthMobile="80vw" marginR="3vw" />
                    </div>
                </Caixa>
            )
        }
        return partes
    }
}

export default Terceirizados